<template>
  <div
    class="modal right fade trader-info c-offer-modal"
    id="trader-info"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"       
  >
    <div class="modal-dialog modal-dialog-centered modal-lg inv-create modal-width" role="document" @click="showDropdown = false">
      <div class="modal-content">
        <div class="modal-header">
          <h5 v-if="mode == 'ADD' || mode == 'MERGE'" class="modal-title" >Create Offer</h5>
          <h5  v-if="mode == 'EDIT'" class="modal-title" >Edit Offer</h5>
          <h5  v-if="mode == 'TRADE'" class="modal-title" >Create Trade</h5>
          <div>
            <span v-if="isUploadInProgress()" class="alert alert-danger" role="alert">
                Holding upload is currently in progress. Please try again once it’s complete.
            </span>
            </div>
          <div class="float-right">
            <span v-if="errors.length" class="mr-3">
              <span class="alert alert-danger" role="alert" v-for="error in errors" v-bind:key="error">{{ error }}</span>                
            </span>
            <button type="button" class="btn btn-secondary"  @click="$emit('close')">Cancel</button>
            <button  v-if="mode == 'ADD' || mode == 'MERGE'" :disabled="isUploadInProgress() || loading || ecnAccountListLoading || isHoldingValuesChanged" type="button" @click="checkOfferPricesValid('NEWOFFER')" class="btn btn-primary">CREATE OFFER</button>
            <button  v-if="mode == 'EDIT'" :disabled="isUploadInProgress() || loading || isHoldingValuesChanged" type="button" @click="checkOfferPricesValid('EDITOFFER')" class="btn btn-primary">UPDATE OFFER</button>
            <button  v-if="mode == 'TRADE'" :disabled="isUploadInProgress() || loading || isHoldingValuesChanged" type="button" @click="checkOfferPricesValid('TRADEOFFER')" class="btn btn-primary">CREATE TRADE</button>
            <button type="button" class="close"  @click="$emit('close')"><span aria-hidden="true">&times;</span></button>
          
          </div>
          
        </div>
        <div class="modal-body">
          <div class="bg-secondary">
            <form v-if="!addCusipFlag" @submit.prevent="">
                <div class="form-row">
                    <div class="form-group">
                        <label for="inputEmail4">SEARCH CUSIP</label>
                        <input
                            type="text"
                            v-model="selectedCusip.cusip"
                            class="form-control"
                            id="account"
                            maxlength="9"
                            placeholder="Enter Cusip"
                            :disabled="mode == 'EDIT'"
                        />
                        <div v-if="mode == 'ADD' || mode == 'TRADE' " class="form-group-append">
                          <button @click="searchCusip()" class="btn ibtn" type="button"><i class="fas fa-search active cursor-pointer" aria-hidden="true"></i></button>
                        </div>
                        
                    </div>
                    <div class="form-group">
                        <label for="inputEmail4">MATURITY DATE</label>
                        <div class="cusip-info"> {{selectedCusip.maturityDate ? moment(selectedCusip.maturityDate).format("MM/DD/YYYY") : "N/A"}}</div>

                    </div>
                      <div class="form-group">
                        <label for="inputEmail4">CALL DATE</label>
                        <div class="cusip-info">{{selectedCusip.callDate ? moment(selectedCusip.callDate).format("MM/DD/YYYY") : "N/A"}}</div>
                    </div>
                      <div class="form-group">
                        <label for="inputEmail4">COUPON</label>
                        <div class="cusip-info">{{selectedCusip.coupon | percent(3)}}</div>
                    </div>
                    <div class="form-group">
                        <label for="inputEmail4">STATE/INSURER</label>
                        <div class="cusip-info">{{getStateName(selectedCusip.stateId)}} / {{selectedCusip.bondInsurer ? selectedCusip.bondInsurer : "N/A"}}</div>
                    </div>
                </div>
                <div class="form-row" v-if="!selectedCusip.id" style="color:#FF9E47"> No cusip selected.</div>
            </form> 

            <form v-if="addCusipFlag" @submit.prevent="">
              <div class="form-row">
                  <div class="form-group col-md-3 required">
                      <label for="inputEmail4">SEARCH CUSIP</label>
                      <input
                          type="text"
                          v-model="addCusipObj.cusip"
                          class="form-control"
                          id="account"
                          maxlength="9"
                          placeholder="Enter Cusip"
                      />
                  </div>
                  <div class="form-group col-md-3 required">
                      <label for="inputEmail4">COUPON</label>
                        <input
                          type="number"
                          class="form-control"
                          v-model="addCusipObj.coupon"
                          placeholder="Enter Coupon"
                        />

                  </div>
                    <div class="form-group col-md-3">
                      <label for="inputEmail4">CALL DATE</label>
                      <datepicker v-model="addCusipObj.callDate" placeholder="mm/dd/yyyy" typeable name="callDate" format="MM/dd/yyyy" :clear-button="true" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker>
                  </div>
                    <div class="form-group col-md-3 required">
                      <label for="inputEmail4">MATURITY DATE</label>
                      <datepicker v-model="addCusipObj.maturityDate" placeholder="mm/dd/yyyy" typeable name="maturitydate" format="MM/dd/yyyy" :clear-button="true" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker>                    </div>
                  <div class="form-group col-md-3 required">
                      <label for="inputEmail4">STATE</label>
                          <select class="form-control" id="exampleFormControlSelect1"  v-model="addCusipObj.stateId">
                            <option value>Please select</option>
                            <option value="0">No State</option>
                            <option
                            v-for="state in stateConstants"
                            :key="state.id"
                            v-bind:value="state.id"
                          >{{state.name}}</option>
                          </select>
                  </div>
                  <div class="form-group col-md-3 ">
                      <label for="inputEmail4">Bond Insurer</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="addCusipObj.bondInsurer"
                          placeholder="Enter Bond Insurer"
                          maxlength="450"
                        />
                  </div>
                  <div class="form-group col-md-3">
                      <label for="inputEmail4">S&P Rating</label>
                        <select class="form-control" id="exampleFormControlSelect1"  v-model="addCusipObj.ratingSP">
                          <option value>Please select</option>
                          <option
                          v-for="sp in spRatingConstants"
                          :key="sp"
                          v-bind:value="sp"
                        >{{sp}}</option>
                        </select>
                  </div>
                  <div class="form-group col-md-3">
                      <label for="inputEmail4">Moody's Rating</label>
                        <select class="form-control" id="exampleFormControlSelect1"  v-model="addCusipObj.ratingMoody">
                          <option value>Please select</option>
                          <option
                          v-for="moody in moodyConstants"
                          :key="moody"
                          v-bind:value="moody.toUpperCase()"
                        >{{moody}}</option>
                        </select>
                  </div>
                  <div class="form-group col-md-3 required">
                    <label for="inputPassword4">Product</label>
                    <select class="form-control" id="exampleFormControlSelect1"  v-model="addCusipObj.offeringTypeId">
                      <option value>Please select</option>
                      <option value="1">MUNICIPAL</option>
                      <option value="2">CORPORATE</option>                  
                    </select>
                  </div>
                  <div class="form-group col-md-9 required">
                      <label for="exampleFormControlTextarea1">Description</label>
                      <textarea class="form-control" v-model="addCusipObj.description" rows="2" maxlength="450"></textarea>
                  </div>
                  
              </div>
              <div class="form-row">
                  <p v-if="cusipValidationErrors.length">
                    <ul>
                      <li class="alert alert-danger" role="alert" v-for="cusiperror in cusipValidationErrors" v-bind:key="cusiperror">{{ cusiperror }}</li>
                    </ul>
                  </p>
              </div>
              <div v-if="cusipLoading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>

              <div class="form-row d-inline">
                  <button type="button" @click="cancelAddCusip()" class="btn btn-secondary" >Cancel</button>
                  <button type="button" @click="addCusip()" class="btn btn-primary">ADD CUSIP</button>
              </div>
            </form>
            </div>  
            <div class="d-flex bd-highlight mt-3">
              <div class="mr-auto p-2 bd-highlight">
                <h4>HOLDING</h4>
              </div>
            </div>
            <table class="table invt align-items-center table-flush table-hover bidtbl">
              <thead class="thead-light psticky">
                <tr>
                    <th scope="col" class="sort text-left" style="width: 40%">ACCOUNT</th>
                    <th scope="col" class="sort text-left" style="width: 40%">BOUGHT</th>
                    <th scope="col" class="sort text-left" style="width: 40%">SPREAD</th>
                    <th scope="col" class="sort text-left" style="width: 40%">IDC</th>
                    <th scope="col" class="sort">COST</th>
                    <th scope="col" class="sort">AVAILABLE QTY</th>
                    <!-- <th scope="col" class="sort">ASSIGNED QTY</th> -->
                    <th scope="col" class="sort">OFFER QTY</th>
                    <th scope="col" class="sort">OFFER PRICE</th>
                    <th scope="col" class="sort">ACTION</th>
                </tr>
              </thead>
              <tbody class="list no-cursor">
                <!-- NEW INVETORY CREATE START -->
                <tr>
                  <td class="text-left" v-if="offeringObj && offeringObj.createSource && !offeringObj.createSource.toLocaleLowerCase().includes('arbs')">
                    <div class="dropdown" v-on:click.stop.prevent="">
                      <input :disabled="!selectedCusip.id" v-if="Object.keys(selectedAccount).length === 0" ref="dropdowninput" @click="showList()" v-model.trim="inputValue" class="dropdown-input" type="text" placeholder="Select or Search Account" />
                      <div v-else @click="resetSelection" class="dropdown-selected">
                        {{ selectedAccount.customerName}} - {{ selectedAccount.account}}
                      </div>
                      <div v-if="showDropdown && !accountListApiLoaded && selectedCusip.id" class="dropdown-list loader text-center"><img src="@/assets/img/loader.svg" alt=""/></div>
                      <div v-show="showDropdown && accountListApiLoaded" class="dropdown-list">
                        <div @click="selectItem(item)" v-show="itemVisible(item)" v-for="(item , i) in accountList" :key="'A'+ i" class="dropdown-item" v-bind:class="{'cusip-account': item.isCusipAccount}">
                          {{ item.customerName}} - {{ item.account}}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div v-if="invLoading" ><img style="height:46px" src="@/assets/img/loader.svg" alt=""/></div>
                    <ul class="list-group list-group-flush">
                      <li v-for="(inv,dateIndex) in newInventory" :key="dateIndex" class="list-group-item text-left">
                        <div v-if="inv.accountMappingId"><datepicker @selected="boughtDateSelected(inv)" :disabledDates="disabledDatesBought" v-model="inv.boughtDate" placeholder="mm/dd/yyyy" typeable name="callDate" format="MM/dd/yyyy" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker></div>
                        <div v-if="!inv.accountMappingId">{{inv.boughtDate ? moment(inv.boughtDate).format("MM/DD/YYYY") : 'N/A'}}</div>
                      </li>
                    </ul>
                  </td>
                  <td>
                    <ul class="list-group list-group-flush">
                      <li v-for="(inv,costIndex) in newInventory" :key="costIndex" class="list-group-item text-left">
                        <div>{{inv.spread}}</div>
                      </li>
                    </ul>
                  </td>
                  <td>
                    <ul class="list-group list-group-flush">
                      <li v-for="(inv,closingPx) in newInventory" :key="closingPx" class="list-group-item text-left">
                        <div>{{inv.closingPx}}</div>
                      </li>
                    </ul>
                  </td>
                  <td>
                    <ul class="list-group list-group-flush">
                      <li v-for="(inv,costIndex) in newInventory" :key="costIndex" class="list-group-item ">
                        <div ><input type="number" @change="setSpreadToOfferPrice(inv)" class="form-control qty" v-model.number="inv.cost"/></div>
                        <!-- <div v-if="!inv.accountMappingId">{{inv.cost}}</div> -->
                      </li>
                    </ul>
                  </td>
                  <td>
                    <ul class="list-group list-group-flush">
                        <li v-for="(inv,qtyIndex) in newInventory" :key="qtyIndex" class="list-group-item">
                          <div ><input onkeypress="return event.charCode >= 48 && event.charCode <= 57" type="number" class="form-control qty" v-model.number="inv.quantity"/></div>
                          <!-- <div v-if="!inv.accountMappingId">{{inv.quantity}}</div> -->
                        </li>
                    </ul>
                  </td>
                    <!-- <td>
                    <ul class="list-group list-group-flush">
                        <li v-for="(inv,assignQty) in newInventory" :key="assignQty" class="list-group-item">
                         
                          <div>{{inv.assignedQuantity ? inv.assignedQuantity : 0 }}</div>
                        </li>
                    </ul>
                  </td> -->
                  <td>  
                    <ul class="list-group list-group-flush">
                      <li v-for="(inv,updateQtyIndex) in newInventory" :key="updateQtyIndex" class="list-group-item">
                        <div ><input onkeypress="return event.charCode >= 48 && event.charCode <= 57" type="number" class="form-control qty" v-model.number="inv.updateQuantity"/></div>
                      </li>
                    </ul>
                  </td>
                  <td>
                    <ul class="list-group list-group-flush">
                        <li v-for="(inv,updatePriceIndex) in newInventory" :key="updatePriceIndex" class="list-group-item">
                          <div ><input type="number" class="form-control qty" v-model.number="inv.updatePrice"/></div>
                        </li>
                    </ul>
                  </td>
                  <td>
                    <button v-if="newInventory.length > 0" @click="addNewInventory(newInventory)" class="btn btn-outline-success" title="Add"><i class="fas fa-plus"></i></button>
                  </td>
                </tr>
                <!-- NEW INVETORY CREATE END -->
                <!-- ADDED INVETORY START -->
                <tr v-if="addedInventory.length == 0">
                  <td colspan="8" style="color:#FF9E47"> No holding added yet.</td>
                </tr>
                <tr v-for="(data,invIndex) in addedInventory" :key="invIndex">
                  <td class="text-left">
                    <span>{{ data.account.customerName}} - {{ data.account.account}}</span>
                  </td>
                  <td>
                    <ul class="list-group list-group-flush">
                      <li v-for="(inv,addeddateIndex) in data.inventory" :key="addeddateIndex" class="list-group-item text-left">
                        <div>{{inv.boughtDate ? moment(inv.boughtDate).format("MM/DD/YYYY") : "N/A"}}</div>
                      </li>
                    </ul>
                  </td>
                    <td>
                    <ul class="list-group list-group-flush">
                      <li v-for="(inv,addedspradIndex) in data.inventory" :key="addedspradIndex" class="list-group-item text-left">
                        <div>{{inv.spread}}</div>
                      </li>
                    </ul>
                  </td>
                  <td>
                    <ul class="list-group list-group-flush">
                      <li v-for="(inv,closingPx) in  data.inventory" :key="closingPx" class="list-group-item text-left">
                        <div>{{inv.closingPx}}</div>
                      </li>
                    </ul>
                  </td>
                  <td>
                    <ul class="list-group list-group-flush">
                      <li v-for="(inv,addedcostIndex) in data.inventory" :key="addedcostIndex" class="list-group-item">
                        <div>{{inv.cost | currency}}</div>
                      </li>
                    </ul>
                  </td>
                  <td>
                    <ul class="list-group list-group-flush">
                        <li v-for="(inv,addedqtyIndex) in data.inventory" :key="addedqtyIndex" class="list-group-item">
                          <!-- <div>{{inv.quantity}}</div> -->
                          <div><input @change="holdingChanged()" onkeypress="return event.charCode >= 48 && event.charCode <= 57" type="number" class="form-control qty" v-model.number="inv.quantity"/></div>
                        </li>
                    </ul>
                  </td>
                  <!-- <td>
                    <ul class="list-group list-group-flush">
                        <li v-for="(inv,addedassignIndex) in data.inventory" :key="addedassignIndex" class="list-group-item">
                          <div>{{inv.assignedQuantity ? inv.assignedQuantity : 0}}</div>
                        </li>
                    </ul>
                  </td> -->
                  <td>
                    <ul class="list-group list-group-flush">
                      <li v-for="(inv,addedInvqty) in data.inventory" :key="addedInvqty" class="list-group-item">
                        <div><input @change="holdingChanged()" onkeypress="return event.charCode >= 48 && event.charCode <= 57" type="number" class="form-control qty" v-model.number="inv.updateQuantity"/></div>
                      </li>
                    </ul>
                  </td>
                  <td>
                    <ul class="list-group list-group-flush">
                        <li v-for="(inv,addedInvprice) in data.inventory" :key="addedInvprice" class="list-group-item">
                          <div><input @change="holdingChanged()" type="number" class="form-control qty" v-model.number="inv.updatePrice"/></div>
                        </li>
                    </ul>
                  </td>
                  <td class="text-center d-flex">
                    <button :class="{ shake: isHoldingValuesChanged }" @click="updateInventory(data.inventory)" class="btn btn-outline-primary btn-sm" title="update"><i class="fas fa-check"></i></button>
                    <button @click="deleteInventory(invIndex,data.inventory)" class="btn btn-outline-danger btn-sm" title="Delete"><i class="far fa-trash-alt"></i></button>
                  </td>
                </tr>
                <!-- ADDED INVETORY END -->
              </tbody>
            </table>    
            <div><hr></div>
            <div class="d-flex bd-highlight mt-3" v-if="deletedInventoryListInOffer.length > 0">
              <div class="mr-auto p-2 bd-highlight">
                <h4>DELETED HOLDING</h4>
              </div>
            </div>
            <table v-if="deletedInventoryListInOffer.length > 0" class="table invt align-items-center table-flush table-hover bidtbl">
              <thead class="thead-light psticky">
                <tr>
                    <th scope="col" class="sort">ACCOUNT</th>
                    <th scope="col" class="sort">BOUGHT</th>
                    <th scope="col" class="sort">SPREAD</th>
                    <th scope="col" class="sort">COST</th>
                    <th scope="col" class="sort">QTY</th>
                </tr>
              </thead>
              <tbody class="list no-cursor">
                <tr v-for="(inv,deletedIndex) in deletedInventoryListInOffer" :key="deletedIndex" >
                  <td>{{inv.customerName}}-{{inv.account}}</td>
                  <td>{{inv.boughtDate}}</td>
                  <td>{{inv.spread}}</td>
                  <td>{{inv.cost | currency}}</td>
                  <td>{{inv.quantity}}</td>
                </tr>
              </tbody>
            </table>    
            <div v-if="deletedInventoryListInOffer.length > 0"><hr></div>
            <div class="d-flex bd-highlight">
              <div class="p-2"><h4>OFFERINGS</h4></div>
              <div v-if="loading || ecnAccountListLoading" class="p-2 flex-fill bd-highlight" style="margin: -40px;"><img src="@/assets/img/loader.svg" alt=""/></div>
            </div>
              <form>
                <div class="form-row">
                    <div class="form-group col-md-3 required">
                        <label for="Quantity">Offering Quantity</label>
                        <input disabled  type="number" class="form-control" id="Quantity" placeholder="Enter Qty"  v-model.number="offerQuantity" >
                    </div>
                    <div class="form-group col-md-3 required">
                        <label for="Cost">Avg Cost</label> 
                        <input step="any" @keyup="setOfferingSpread()" type="number" class="form-control" id="Cost" placeholder="0.00"  v-model.number="offerCost" >
                    </div>
                      <div class="form-group col-md-3 required">
                        <label for="Price">Offering Price</label>
                        <input step="any" @change="getYieldValue()" @keyup="setEcnPriceDefault(offerPrice)" type="number" class="form-control" id="Price" placeholder="0.00"  v-model.number="offerPrice" >
                        <span  v-if="offerPrice < offerCost" class="warning-message">offer is been created at a loss</span><br>
                    </div>
                      <div class="form-group col-md-3">
                        <label for="Yield">Yield</label><span v-if="selectedCusip.id" @click="yieldModalOpen = true" class="yld-text"><button type="button" class="btn btn-primary btn-sm">Yld. Calc</button></span>
                        <input step="any" @change="getPriceValue()" type="number" class="form-control" id="Yield" placeholder="0.00" v-model.number="calculatedYield" >
                        <!-- <span class="warning-message" v-if="!secMasterAvailable" >Security master fields are not available to calculate yield.</span> -->
                    
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-3">
                        <label for="Spread">Spread</label>
                        <input disabled type="number" class="form-control" id="Spread" placeholder="0.00"  v-model.number="yieldSpread" >
                    </div>
                    <div v-if="this.mode !='TRADE'" class="form-group col-md-3 required">
                        <label for="Min">Min</label>
                        <input type="number" class="form-control" id="Min"  placeholder="0.00" v-model.number="offeringObj.minimum" >
                    </div>
                      <div v-if="this.mode !='TRADE'" class="form-group col-md-3 required">
                        <label for="Inc">Inc</label>
                        <input type="number" class="form-control" id="Inc" placeholder="0.00" v-model.number="offeringObj.incrementVal" >
                    </div>
                      <div v-if="this.mode !='TRADE'" class="form-group col-md-3 required">
                        <label for="Return">Min Bal Remain</label>
                        <input type="number" class="form-control" id="Return" placeholder="0.00" v-model.number="offeringObj.balance" >
                    </div>
                </div>
                <div v-if="this.mode !='TRADE'" class="form-row">
                    <div class="form-group col-md-4 " v-bind:class="{'required': this.platform !='ARBS'}">
                        <label for="tmcbrocker">TMC Account</label>
                        <select class="form-control" v-model="offeringObj.tmcBrokerAccountId" >
                          <option value="">Choose A/C No</option>
                          <option v-if="tmcAccountList.length == 0" value="">Loading...</option>
                          <option
                              v-for="tmc in tmcAccountList"
                              :key="tmc.id"
                              v-bind:value="tmc.id"
                          >{{tmc.account}}</option>
                      </select>
                    </div>
                    <div class="form-group col-md-4 " v-bind:class="{'required': this.platform !='ARBS'}">
                        <label for="bondpointbrocker">BondPoint Account</label>
                        <select class="form-control" v-model="offeringObj.ibpBrokerAccountId" >
                            <option value="">Choose A/C No</option>
                            <option v-if="bpAccountList.length == 0" value="">Loading...</option>
                            <option
                                v-for="bp in bpAccountList"
                                :key="bp.id"
                                v-bind:value="bp.id"

                            >{{bp.account}}</option>
                        </select>
                    </div>
                      <div class="form-group col-md-4" v-bind:class="{'required': this.platform !='ARBS'}">
                        <label for="tradewebbrocker">TradeWeb Account</label>
                        <select class="form-control mb-2" v-model="offeringObj.twdBrokerAccountId" >
                            <option value="">Choose A/C No</option>
                            <option v-if="twAccountList.length == 0" value="">Loading...</option>
                            <option
                                v-for="tw in twAccountList"
                                :key="tw.id"
                                v-bind:value="tw.id"
                            >{{tw.account}}</option>
                        </select>
                    </div>
                    <div class="form-group col-md-4" v-bind:class="{'required': this.platform !='ARBS'}">
                        <label for="tradewebbrocker">Market Axess Account</label>
                        <select class="form-control mb-2" v-model="offeringObj.mktxBrokerAccountId" >
                            <option value="">Choose A/C No</option>
                            <option v-if="mktxAccountList.length == 0" value="">Loading...</option>
                            <option
                                v-for="mktx in mktxAccountList"
                                :key="mktx.id"
                                v-bind:value="mktx.id"
                            >{{mktx.account}}</option>
                        </select>
                    </div>
                    
                </div>
                <div class="form-row justify-content-start">
                    <div class="form-group col-md-4 required">
                      <label for="validity">Settlement Date</label>
                      <datepicker  @selected="settilementDateSelected()" :disabledDates="disabledDatesSettlement"  v-model="offeringObj.settlementDate" placeholder="mm/dd/yyyy" typeable name="callDate" format="MM/dd/yyyy" :clear-button="false" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker>
                    </div>
                    <div class="form-group col-md-4 required">
                        <label for="YieldPrice">Yield/Price</label>
                        <select class="form-control"  v-model="offeringObj.offerType" >
                          <option value="">Please select</option>
                          <option value="YIELD">Yield</option>
                          <option value="PRICE">Price</option>
                        </select>
                    </div>
                    <div v-if="this.mode == 'TRADE'" class="form-group col-md-4 required">
                      <label for="validity">Executed At</label>
                      <datetime :disabled-dates="disabledDatesBought" format="MM/DD/YYYY h:i:s" width="100%" v-model="executedAt" placeholder="MM/DD/YYYY h:i:s"></datetime>
                      <!-- <datepicker :disabledDates="disabledDatesBought"  v-model="executedAt" placeholder="mm/dd/yyyy" typeable name="callDate" format="MM/dd/yyyy" :clear-button="true" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker> -->
                    </div>
                    <div v-if="this.mode == 'TRADE'" class="form-group col-md-4 required">
                      <label for="validity">Interest</label>
                       <input type="number" class="form-control" id="Return" placeholder="0.00" v-model.number="offeringObj.executedInterest" >
                    </div>
                    <div v-if="this.mode == 'TRADE'" class="form-group col-md-4 required">
                      <label for="validity">Success ECN</label>
                      <select v-on:click.stop.prevent="" class="form-control number" id="exampleFormControlSelect1"  v-model="successECN">
                            <option value="IBP">Bond Point</option>
                            <option value="TWD">TWR</option>
                            <option value="TMC">TMC</option>
                            <option value="MKTX">MKTX</option>
                        </select>
                    </div>
                    <div v-if="this.mode == 'TRADE'" class="form-group col-md-4 required">
                      <label for="validity">Success ECN Account</label>
                      <select v-if="successECN == 'TMC'" class="form-control" v-model="offeringObj.brokerAccountId" >
                        <option value="">Choose A/C No</option>
                        <option v-if="tmcAccountList.length == 0" value="">Loading...</option>
                        <option
                            v-for="tmc in tmcAccountList"
                            :key="tmc.id"
                            v-bind:value="tmc.id"
                        >{{tmc.account}}</option>
                      </select>
                      <select v-if="successECN == 'IBP'" class="form-control" v-model="offeringObj.brokerAccountId" >
                        <option value="">Choose A/C No</option>
                        <option v-if="bpAccountList.length == 0" value="">Loading...</option>
                        <option
                            v-for="bp in bpAccountList"
                            :key="bp.id"
                            v-bind:value="bp.id"

                        >{{bp.account}}</option>
                      </select>
                      <select v-if="successECN == 'TWD'" class="form-control mb-2" v-model="offeringObj.brokerAccountId" >
                        <option value="">Choose A/C No</option>
                        <option v-if="twAccountList.length == 0" value="">Loading...</option>
                        <option
                            v-for="tw in twAccountList"
                            :key="tw.id"
                            v-bind:value="tw.id"
                        >{{tw.account}}</option>
                      </select>
                      <select v-if="successECN == 'MKTX'" class="form-control mb-2" v-model="offeringObj.brokerAccountId" >
                            <option value="">Choose A/C No</option>
                            <option v-if="mktxAccountList.length == 0" value="">Loading...</option>
                            <option
                                v-for="mktx in mktxAccountList"
                                :key="mktx.id"
                                v-bind:value="mktx.id"
                            >{{mktx.account}}</option>
                        </select>

                      
                    </div>
                    
                </div>
              </form>
              <div v-if="this.mode !='TRADE'"><hr></div>
              <form v-if="this.mode !='TRADE'" class="d-flex justify-content-start">
                <div v-if="offeringObj && offeringObj.createSource && !offeringObj.createSource.toLocaleLowerCase().includes('arbs')">
                <div class="form-check form-check-inline">
                <input type="checkbox" class="form-check-input" @click="statusChanged('MSRB')" v-model="checkedStatus"  value="HOLD" >
                <label class="form-check-label" for="inlineCheckbox1">Hold</label>
              </div>
              <div class="form-check form-check-inline">
                <input type="checkbox" class="form-check-input" @click="statusChanged('HOLD')" v-model="checkedStatus"  value="MSRB">
                <label class="form-check-label" for="inlineCheckbox1">Move to Msrb</label>
              </div>
              <!-- <div class="form-check form-check-inline">
                <input type="checkbox" class="form-check-input" v-model="offeringObj.isWellsFargo"  value="Wells Fargo">
                <label class="form-check-label" for="inlineCheckbox1">Wells Fargo</label>
              </div> -->
              <div class="form-check form-check-inline">
                <input type="checkbox" class="form-check-input" v-model="offeringObj.isStaticOffer" value="static">
                <label class="form-check-label" for="inlineCheckbox1">Static Offer</label>
              </div>
                </div>
              </form>  
              <div v-if="this.mode !='TRADE'"><hr/></div>
              <form v-if="this.mode !='TRADE'">
                <div class="form-row" v-if="offeringObj && offeringObj.createSource && !offeringObj.createSource.toLocaleLowerCase().includes('arbs')">
                    <div class="form-group col-md-3 required">
                        <label for="inputEmail4">TMC</label>
                        <input  type="number" class="form-control" id="inputEmail4"  v-model.number="offerTmcPrice" placeholder="0.00" >
                    </div>
                    <div class="form-group col-md-3 required">
                        <label for="TWD">TWR</label>
                        <input type="number" class="form-control" id="TWD"  v-model.number="offerTwdPrice" placeholder="0.00">
                    </div>
                      <div class="form-group col-md-3 required">
                        <label for="KBP">KBP</label>
                        <input type="number" class="form-control" id="KBP"  v-model.number="offerIbpPrice" placeholder="0.00">
                    </div>
                    <div class="form-group col-md-3 required">
                        <label for="KBP">MKTX</label>
                        <input type="number" class="form-control" id="offerMktxPrice"  v-model.number="offerMktxPrice" placeholder="0.00">
                    </div>
                </div>
              </form>  
        </div>
      </div>
    </div>
    <YieldCalculator 
      v-bind:offerPrice="offerPrice" 
      v-bind:offerYield="calculatedYield" 
      v-bind:cusipid="selectedCusip.id" 
      v-bind:settlementDate="this.orgSettings.settlementDate" 
      v-if="yieldModalOpen" 
      @close="yieldModalOpen = false"
      @yieldupdate="setCalculatedYield"
      @priceupdate="setCalculatedPrice"/>
    <OfferSendToEcn 
      v-if="sentToEcnModalOpen"
      v-bind:offerSenttoEcn="offerSenttoEcn" 
      @close="closeSenttoEcnModal()"/>
  </div>
</template>

<script>
    import authService from "@/authService";
    import config from "@/config";
    import stateConstants from "@/stateConstants";
    import Datepicker from 'vuejs-datepicker';
    import moodyConstants from "@/moodyRatingConstants";
    import spRatingConstants from "@/spRatingConstants";
    import YieldCalculator from "./ImsYieldCalculator";
    import OfferSendToEcn from "./ImsSentToEcnsModal"
    import datetime from 'vuejs-datetimepicker';
    export default {
        name: 'addnewoffermodal',
        components :{
            Datepicker,
            YieldCalculator,
            OfferSendToEcn,
            datetime
        },
        props: ['offerCusip','mode','selectedOffer','offerInventory','waitingOfferingIds','cancelOfferingIds','platform'],
        data() {
            return {
                loading : false,
                errors: [],
                stateConstants: stateConstants,
                offeringObj : {},
                cusipInventory : [],
                checkedStatus: [],
                customerList:[],
                cusipValue:null,
                addCusipFlag : false,
                addCusipObj : {},
                moodyConstants:moodyConstants,
                spRatingConstants:spRatingConstants,
                cusipValidationErrors:[],
                cusipLoading:false,
                selectedCusip:{},
                selectedAccount: {},
                inputValue: '',
                accountList: [],
                accountListApiLoaded: false,
                showDropdown : false,
                addedInventory : [],
                newInventory:[],
                invLoading:false,
                tmcAccountList : [],
                bpAccountList : [],
                twAccountList : [],
                mktxAccountList : [],
                traderSettings : {},
                bidValidity : 3,
                offerPrice : 0,
                offerQuantity : 0,
                offerCost : 0,
                yieldModalOpen : false,
                orgSettings : {},
                disabledDatesBought: {
                    from : new Date()
                },
                disabledDatesSettlement: {
                    to : this.getYestedayDate()
                },
                deletedInventoryIds : [],
                sentToEcnModalOpen : false,
                offerSenttoEcn : null,
                inventoryListInOffer : [],
                ecnData : null,
                yieldSpread : 0,
                calculate : {},
                offerTmcPrice : 0,
                offerIbpPrice : 0,
                offerTwdPrice : 0,
                offerMktxPrice : 0,
                successECN : "IBP",
                executedAt : "",
                ecnAccountListLoading : false,
                calculatedYield : 0,
                secMasterAvailable : true,
                isHoldingValuesChanged : false,
                deletedInventoryListInOffer : [],
                inventoryIDC : 0,
                inventoryAccounts : []
            };
        },
        methods: {
          holdingChanged(){
            console.log("Holding values changed");
            this.isHoldingValuesChanged = true;
          },
          boughtDateSelected(inv){
            /**
            * Get spread value for bought date.
            * There is a delay in 'inv.boughtDate' model changes so that's why we use setTimeout to avoid this this issue. 
            */
            setTimeout(() => {
              this.getSpread(inv);
            },500);
          },
          settilementDateSelected(){
            /**
            * Get yield value when settilement date changes.
            * There is a delay in 'offeringObj.settlementDate' model changes so that's why we use setTimeout to avoid this this issue. 
            */
            setTimeout(() => {
              this.getYieldValue();
            },500);
          },
          closeSenttoEcnModal(){
            /**
            * Close offer create/edit model popup.
            * Also emit events
            * close event for closing popup
            * offercreatedorupdated event for refresh list page after create or edit offer
            */
            this.sentToEcnModalOpen = false
            this.$emit('close');               
            this.$root.$emit("offercreatedorupdated");
          },
          getStateName(id){
            /**
            * Return state name 
            */
            return id ? this.stateConstants.find(x => x.id === id).short : 'N/A';
          },
          statusChanged(checkedName){
            /**
            * Set offer status(HOLD,MSRB) 
            * Can't select multiple offer status.This timeout function will prevent multi select 
            */
            setTimeout(() => {
               this.checkedStatus = this.checkedStatus.filter(name => name !== checkedName);
            },100)
          },
          checkOfferPriceDiff(offerPrice,tmcPrice,twdPrice,ibpPrice){
            let tmcDiff = Math.abs(offerPrice - tmcPrice);
            let twdDiff = Math.abs(offerPrice - twdPrice);
            let ibpDiff = Math.abs(offerPrice - ibpPrice);
            if(tmcDiff > 1 || twdDiff > 1 || ibpDiff > 1){
              return false
            }else{
              return true;
            }
          },
          checkOfferPricesValid(type){
            let isPriceDiffValid = this.checkOfferPriceDiff(
              parseFloat(this.offerPrice).toFixed(3),
              parseFloat(this.offerTmcPrice).toFixed(3),
              parseFloat(this.offerTwdPrice).toFixed(3),
              parseFloat(this.offerIbpPrice).toFixed(3)
            );
            
            if(!isPriceDiffValid){
              this.$confirm("The difference between the offer price and the ECN'S prices is greater than $1.","Are you sure","question",{confirmButtonText:"Yes",cancelButtonText : "No"}).then(() => {
                this.handleOfferAction(type);
              });
            }else{
              if(this.isOfferAboveIDC()){
                  var message = "Offering price is above IDC";
                  this.$confirm(message,"Are you sure","question",{confirmButtonText:"Yes",cancelButtonText : "No"}).then(() => {
                    this.handleOfferAction(type);
                  })
              }else{
                this.handleOfferAction(type);
              }
            }
          },
          handleOfferAction(type) {
            switch (type) {
              case "NEWOFFER":
                this.createNewOffer();
                break;
              case "EDITOFFER":
                this.updateOffer();
                break;
              case "TRADEOFFER":
                this.createTrade();
                break;
              default:
                break;
            }
          },
          isOfferAboveIDC() {
            let isInventoryHoldingAdded = this.addedInventory.some(data =>
              this.inventoryAccounts.includes(data.account.account)
            );
            return isInventoryHoldingAdded && this.inventoryIDC && this.inventoryIDC < this.offerPrice;
          },
          createNewOffer(){
            /**
            * Create New Offer 
            * isValid for validating offer form
            */
            let isValid = this.checkForm(); 
            if (isValid) {
                this.loading = true;
                var newOfferObj = {};
                  newOfferObj = { ...this.offeringObj};
                  newOfferObj.yield = this.calculatedYield;
                  newOfferObj.userId = this.traderSettings.id;
                  newOfferObj.cusipId = this.selectedCusip.id;
                  newOfferObj.status  = this.checkedStatus.length > 0 ? this.checkedStatus[0] : 'NEW';
                  newOfferObj.createSource  = "self";
                  newOfferObj.isStaticOffer = this.offeringObj.isStaticOffer ? this.offeringObj.isStaticOffer : false;
                  newOfferObj.isWellsFargo = this.offeringObj.isWellsFargo ? this.offeringObj.isWellsFargo : false;
                  newOfferObj.assignInventoryToOfferDtoList = this.getExisitingInventoryList();
                  newOfferObj.inventoryAddDtoList = this.getNewInventoryList();
                  newOfferObj.price = parseFloat(this.offerPrice).toFixed(3);
                  newOfferObj.quantity = this.offerQuantity;
                  newOfferObj.cost = parseFloat(this.offerCost).toFixed(3); 
                  newOfferObj.yieldSpread = this.yieldSpread; 
                  newOfferObj.cancelOfferingIds = this.cancelOfferingIds ? this.cancelOfferingIds  : []; 
                  newOfferObj.waitingOfferingIds = this.waitingOfferingIds ? this.waitingOfferingIds : []; 
                  newOfferObj.tmcPrice = parseFloat(this.offerTmcPrice).toFixed(3);
                  newOfferObj.ibpPrice = parseFloat(this.offerIbpPrice).toFixed(3); 
                  newOfferObj.twdPrice = parseFloat(this.offerTwdPrice).toFixed(3);
                  newOfferObj.settlementDate = this.offeringObj.settlementDate ? this.moment(this.offeringObj.settlementDate).format("MM/DD/YYYY") : "";
                  newOfferObj.mktxPrice = parseFloat(this.offerMktxPrice).toFixed(3);
                  // newOfferObj.mktxBrokerAccountId = 2214 
                
                  const auth = {
                    headers: { 'org-token' : authService.getOrgToken()  }
                };
                this.$http
                .post(config.baseUrlBidSide + "/offer", newOfferObj, auth)
                .then((result) => {
                  this.$alert("Offer created successfully","","success");
                  this.loading = false;
                  if(result.data.show){
                    this.sentToEcnModalOpen = true;
                    this.offerSenttoEcn = result.data
                  }else{
                    this.$emit('close');               
                    this.$root.$emit("offercreatedorupdated");
                  }
                })
                .catch(() => {
                    this.loading = false;              
                });
            }
          },
          createTrade(){
            /**
            * Create New External Trade 
            * Offer created out side Ims platform
            */
            let isValid = this.checkForm(); 
            if (isValid) {
                this.loading = true;
                var newOfferObj = {};
                  newOfferObj.offerType = this.offeringObj.offerType;
                  newOfferObj.offerValidity = 1;
                  newOfferObj.settlementDate = this.offeringObj.settlementDate ? this.moment(this.offeringObj.settlementDate).format("MM/DD/YYYY") : "";
                  newOfferObj.userId = this.traderSettings.id; 
                  newOfferObj.yield = this.calculatedYield; 
                  newOfferObj.cusipId = this.selectedCusip.id;
                  newOfferObj.status  = "SUCCESS";
                  newOfferObj.createSource  = "self";
                  newOfferObj.inventoryAddDtoList = this.getNewInventoryList();
                  newOfferObj.assignInventoryToOfferDtoList = this.getExisitingInventoryList();
                  newOfferObj.price = parseFloat(this.offerPrice).toFixed(3);
                  newOfferObj.quantity = this.offerQuantity;
                  newOfferObj.cost = parseFloat(this.offerCost).toFixed(3); 
                  newOfferObj.yieldSpread = this.yieldSpread;
                  newOfferObj.successECN =  this.successECN;
                  newOfferObj.executedAt =  this.moment(this.executedAt).utc().format("MM/DD/YYYY HH:mm:ss") ;
                  newOfferObj.brokerAccountId =  this.offeringObj.brokerAccountId;
                  newOfferObj.executedInterest =  this.offeringObj.executedInterest;
                  
                const auth = {
                    headers: { 'org-token' : authService.getOrgToken()  }
                };
                this.$http
                .post(config.baseUrlBidSide + "/offer/external", newOfferObj, auth)
                .then(() => {
                  this.$alert("Trade created successfully","","success");
                  this.loading = false;
                  this.$emit('close');
                })
                .catch(() => {
                    this.loading = false;              
                });
            }

          },
          updateOffer(){
            /**
            * EDIT OFFER 
            */
            let isValid = this.checkForm(); 
            let isHolodingQtyValid = this.checkOfferHoldingQuantityValid(); 
            if(!isHolodingQtyValid){
              return false
            }
            if (isValid) {
                this.loading = true;
                var newOfferObj = {};
                    newOfferObj.updateOfferingId = this.offeringObj.id;
                    newOfferObj.offerType = this.offeringObj.offerType;
                    newOfferObj.offerValidity = 1;
                    newOfferObj.settlementDate = this.offeringObj.settlementDate ? this.moment(this.offeringObj.settlementDate).format("MM/DD/YYYY") : "";
                    newOfferObj.tmcBrokerAccountId = this.offeringObj.tmcBrokerAccountId;
                    newOfferObj.ibpBrokerAccountId = this.offeringObj.ibpBrokerAccountId;
                    newOfferObj.twdBrokerAccountId = this.offeringObj.twdBrokerAccountId;
                    newOfferObj.mktxBrokerAccountId = this.offeringObj.mktxBrokerAccountId;
                    newOfferObj.balance = this.offeringObj.balance; 
                    newOfferObj.minimum = this.offeringObj.minimum; 
                    newOfferObj.incrementVal = this.offeringObj.incrementVal; 
                    newOfferObj.yieldSpread = this.yieldSpread; 
                    newOfferObj.userId = this.traderSettings.id; 
                    newOfferObj.cusipId = this.selectedCusip.id;
                    let offerStatus = this.offeringObj.status;
                    if(this.checkedStatus.length > 0){
                      offerStatus = this.checkedStatus[0];
                    }else if(this.offeringObj.status == 'HOLD' || this.offeringObj.status == 'MSRB' || this.offeringObj.status == 'MSRB_HOLD'){
                      offerStatus = 'NEW';
                    }else{
                      offerStatus = this.offeringObj.status;
                    }
                    newOfferObj.status  = offerStatus;
                    newOfferObj.isStaticOffer = this.offeringObj.isStaticOffer ? this.offeringObj.isStaticOffer : false;
                    newOfferObj.isWellsFargo = this.offeringObj.isWellsFargo ? this.offeringObj.isWellsFargo : false;
                    newOfferObj.assignInventoryToOfferDtoList = this.getExisitingInventoryList();
                    newOfferObj.inventoryAddDtoList = this.getNewInventoryList();
                    newOfferObj.price = parseFloat(this.offerPrice).toFixed(3); 
                    newOfferObj.quantity = this.offerQuantity;
                    newOfferObj.cost = parseFloat(this.offerCost).toFixed(3); 
                    newOfferObj.cancelOfferingIds = [];
                    newOfferObj.waitingOfferingIds = [];
                    newOfferObj.tmcPrice = parseFloat(this.offerTmcPrice).toFixed(3);
                    newOfferObj.ibpPrice = parseFloat(this.offerIbpPrice).toFixed(3); 
                    newOfferObj.twdPrice = parseFloat(this.offerTwdPrice).toFixed(3); 
                    
                    newOfferObj.yield = this.calculatedYield; 
                    newOfferObj.createSource  = "self";
                    newOfferObj.updateByCognitoSub   = authService.getUser().cognitoSub;
                    newOfferObj.mktxPrice = parseFloat(this.offerMktxPrice).toFixed(3);

                 const auth = {
                    headers: { 'org-token' : authService.getOrgToken()  }
                };
                this.$http
                .put(config.baseUrlBidSide + "/offer/update", newOfferObj, auth)
                .then((result) => {
                  this.$alert("Offer updated successfully","","success");
                  this.loading = false;
                  if(result.data.show){
                    this.sentToEcnModalOpen = true;
                    this.offerSenttoEcn = result.data
                  }else{
                    this.$emit('close');               
                    this.$root.$emit("offercreatedorupdated");
                  }

                })
                .catch(() => {
                    this.loading = false;              
                });
                
                
            }
          },
          checkOfferHoldingQuantityValid(){
            /**
            * Validate offer Holding QTY
            */
           var self = this;
           var returnKey = true;
           if(this.offeringObj.status == 'HOLD_ON_HOLDINGS_UPLOAD'){
            this.addedInventory.forEach((result) => {
              result.inventory.forEach((data) => {
                if(data.id){
                  // if((data.quantity - data.assignedQuantity) < data.updateQuantity){
                  //   if(data.quantity == data.assignedQuantity){
                  //     self.$alert("Holding already assigned","","error");
                  //   }else{
                  //     self.$alert("Quantity entered is greater than available quantity to offer.","","error");
                  //   }
                  //   returnKey = false;
                  //   return false;
                  // }
                  if(data.quantity  < data.updateQuantity){
                    self.$alert("Quantity entered is greater than available quantity to offer.","","error");
                    returnKey = false;
                    return false;
                  }
                }
              })
            });
           }
           return returnKey;
          },
          checkForm(){
            /**
            * Validate offer create form
            */
            this.errors = [];
              if (!this.selectedCusip.id) {
                this.errors.push("Cusip is not selected.");
                return false;
              }
              if (this.addedInventory.length == 0) {
                this.errors.push("Offer holding is required.");
                return false;
              }
              if(!this.offerQuantity){
                this.errors.push("Offer quantity is required.");
                return false;
              }
              if(!this.offerCost){
                this.errors.push("Offer cost is required.");
                return false;
              }
              if(!this.offerPrice){
                this.errors.push("Offer price is required.");
                return false;
              }
              if(!this.offerPrice){
                this.errors.push("Offer price is required.");
                return false;
              }
              if(!this.offeringObj.settlementDate){
                this.errors.push("Settlement Date is required.");
                return false;
              }
              if(!this.offeringObj.minimum && this.mode != 'TRADE'){
                this.errors.push("Offer minimum is required.");
                return false;
              }
              if(!this.offeringObj.incrementVal && this.mode != 'TRADE'){
                this.errors.push("Offer increment value is required.");
                return false;
              }
              if(this.platform !='ARBS'){
                if(!this.offeringObj.tmcBrokerAccountId && this.mode != 'TRADE' ){
                  this.errors.push("TMC Account is required.");
                  return false;
                }
                if(!this.offeringObj.twdBrokerAccountId && this.mode != 'TRADE' ){
                  this.errors.push("TradeWeb Account is required.");
                  return false;
                }
                if(!this.offeringObj.ibpBrokerAccountId && this.mode != 'TRADE' ){
                  this.errors.push("BondPoint Account is required.");
                  return false;
                }   
              }           
              if(!this.offerTmcPrice && this.mode != 'TRADE'){
                this.errors.push("Offer TMC Price is required.");
                return false;
              }
              if(!this.offerTwdPrice && this.mode != 'TRADE'){
                this.errors.push("Offer TWD Price is required.");
                return false;
              }
              if(!this.offerIbpPrice && this.mode != 'TRADE'){
                this.errors.push("Offer IBP Price is required.");
                return false;
              }
              if(!this.executedAt && this.mode == 'TRADE'){
                this.errors.push("Offer executed at is required.");
                return false;
              }
              if(!this.successECN && this.mode == 'TRADE'){
                this.errors.push("Offer success Ecn is required.");
                return false;
              }
              if(!this.offeringObj.brokerAccountId && this.mode == 'TRADE'){
                this.errors.push("Offer success Ecn Account is required.");
                return false;
              }
              if(!this.offeringObj.executedInterest && this.mode == 'TRADE'){
                this.errors.push("Offer executed interest is required.");
                return false;
              }
              
            return true

          },
          getExisitingInventoryList(){
            /**
            * Get Inventory list to add in offer.
            * This will return inventory list already in our database.
            * So these inventorys will updated with new values while creating or updating offer.
            * Already added inv have id property so we can check with that.
            */
            var returnnewInv = [];
            this.addedInventory.forEach((result) => {
              result.inventory.forEach((data) => {
                if(data.id){
                  var updatedInventory = {};
                  updatedInventory.quantity = data.quantity;
                  updatedInventory.availableQuantity = data.quantity;
                  updatedInventory.boughtDate = data.boughtDate ? this.moment(data.boughtDate).format("MM/DD/YYYY") : "";
                  updatedInventory.cost = data.cost;
                  updatedInventory.updateQuantity = data.updateQuantity;
                  updatedInventory.updatePrice = data.updatePrice;
                  updatedInventory.spread = data.spread ? data.spread : 0;
                  updatedInventory.inventoryId = data.id;
                  returnnewInv.push(updatedInventory);
                }
                
              })
            });
            return returnnewInv;
          },
          getNewInventoryList(){
            /**
            * Get Inventory list to add in offer.
            * This will return inventory list not in our database.
            * So these inventorys will add to our database while creating or updating offer.
            * Newly added inv doesn't have  id property so we can check with that.
            */
            var returnnewInv = [];
            var self = this;
            this.addedInventory.forEach((result) => {
              result.inventory.forEach((data) => {
                if(!data.id){
                  data.boughtDate =  self.moment(data.boughtDate).format("MM/DD/YYYY");
                  returnnewInv.push(data);
                }
               
              })
            });

            return returnnewInv;
          },
          // getAssignInventoryListForUpdate(){
          //   var returnnewInv = [];
          //   this.addedInventory.forEach((result) => {
          //     result.inventory.forEach((data) => {
          //       if(data.id && !this.inventoryExistInCurrentOffer(data.id)){
          //         var updatedInventory = {};
          //         updatedInventory.updateQuantity = data.updateQuantity;
          //         updatedInventory.updatePrice = data.updatePrice;
          //         updatedInventory.inventoryId = data.id;
          //         returnnewInv.push(updatedInventory);
          //       }
                
          //     })
          //   });
          //   return returnnewInv;
          // },
          // getEditedInventoryListForUpdate(){
          //   var returnnewInv = [];
          //   this.addedInventory.forEach((result) => {
          //     result.inventory.forEach((data) => {
          //       if(data.id && this.inventoryExistInCurrentOffer(data.id)){
          //         var updatedInventory = {};
          //         updatedInventory.updateQuantity = data.updateQuantity;
          //         updatedInventory.updatePrice = data.updatePrice;
          //         updatedInventory.inventoryId = data.id;
          //         returnnewInv.push(updatedInventory);
          //       }
                
          //     })
          //   });
          //   return returnnewInv;
          // },
          inventoryExistInCurrentOffer(invID){
            /**
            * Return inventory id if it is in offer.
            * So we can pass this id to update offer api to delete this inventory from offer.
            */
            let hasInventoryFound = this.inventoryListInOffer.some( inventory => inventory['inventoryId'] === invID );
            return hasInventoryFound;
          },
          // getAccountName(id){
          //   /**
          //   * Return formatted customer name with account number
          //   */
          //   var name;
          //   this.customerList.forEach(function(customer) {
          //       if(customer.accountMappingId == id){
          //         name = customer.customerName+"-"+customer.accountNumber;
          //       }
          //   });
          //   return name;
          // },
          searchCusip(){
            if(this.selectedCusip.cusip.length != 9){
              this.$alert("Enter 9 digit characters long  CUSIP");
              return
            }
            this.loading = true;
            const auth = {
                headers: { 'org-token' : authService.getOrgToken() }
            };
            this.$http
            .get(
              config.baseUrlBidSide +
                "/cusip/list?page=1&status=ACTIVE,BLOCKED&sortColumn=cusip&sortOrder=ASC&type=OFFER"+
                "&cusip=" +
                this.selectedCusip.cusip,
                auth
            )
            .then(result => {
              if(result.data.content.length > 0){
                //if(this.selectedCusip.cusip != result.data.content[0].cusip){
                  this.setCusipAsSelected(result.data.content[0]);
                //}
              }else{
                this.$confirm("Do you want to add this CUSIP?","CUSIP NOT FOUND","",{confirmButtonText:"Yes",cancelButtonText : "No"}).then(() => {
                  this.addCusipObj.cusip = this.selectedCusip.cusip;
                  this.addCusipFlag = true;
                });

              }
              this.loading = false;
            })

          },
          setCusipAsSelected(cusipData){
            if(cusipData){
              this.selectedCusip = { ...cusipData}
              this.resetToDefault();
              this.getAccountListForCusip();
              this.getCusipDetails();

            }
          },
          cancelAddCusip(){
            this.addCusipFlag = false;
          },
          addCusip(){
             let isValid = this.checkCusipValidations();
            if (isValid) {
              this.cusipLoading = true;
              var addData = { ...this.addCusipObj};
              addData.coupon = parseFloat(addData.coupon / 100);
              addData.callDate = addData.callDate ? this.moment(addData.callDate).format("MM/DD/YYYY") : null;            
              addData.maturityDate = addData.maturityDate ? this.moment(addData.maturityDate).format("MM/DD/YYYY") : null;
              this.$http
                .post(config.baseUrlBidSide + "/cusip", addData)
                .then((response) => {
                  this.$alert("CUSIP added successfully");
                  this.cusipLoading = false;
                  response.data.stateId =  response.data.state ? response.data.state.id : null;           
                  this.setCusipAsSelected(response.data);
                  this.addCusipFlag = false;             
                })
                .catch(e => {
                  console.log(e.response);
                  if(e.response.data == "Duplicate CUSIP"){
                    this.$alert("This Cusip already exists.");
                  }
                  this.cusipLoading = false;              
                });
            }
            
          },
          checkCusipValidations(){
            this.cusipValidationErrors = [];
            if (!this.addCusipObj.cusip) {
              this.cusipValidationErrors.push("Cusip number is required.");
              return false;
            }
            if (this.addCusipObj.cusip.length != 9) {
              this.cusipValidationErrors.push("Enter 9 digit characters long  CUSIP");
              return false;
            }
            if (!this.addCusipObj.coupon) {
              this.cusipValidationErrors.push("Coupon is required.");
              return false;
            }
            if (this.addCusipObj.coupon > 100) {
              this.cusipValidationErrors.push("Coupon should be less than 100.");
              return false;
            }
            if (!this.addCusipObj.maturityDate) {
              this.cusipValidationErrors.push("Maturity date is required.");
              return false;
            }
            if (!this.addCusipObj.stateId) {
              this.cusipValidationErrors.push("State is required.");
              return false;
            }
             if (!this.addCusipObj.offeringTypeId) {
              this.cusipValidationErrors.push("Product is required.");
              return false;
            }
            if (!this.addCusipObj.description) {
              this.cusipValidationErrors.push("Description is required.");
              return false;
            }
           
            return true;
               
          },
          resetSelection () {
            this.selectedAccount = {};
            this.showDropdown = true;
            this.$nextTick( () => this.$refs.dropdowninput.focus() )
            
          },
          selectItem (theItem) {
           // if(this.addedInventory.findIndex(x => x.account.accountMappingId === theItem.accountMappingId) == -1){
              this.selectedAccount = theItem 
              this.inputValue = ''
              this.showDropdown = false;
              console.log('on-item-selected', theItem);
              this.newInventory = [];
              this.getAccountInventory(theItem);
            // }
            // else{
            //   this.$alert("Holding already added","","error");
            // }

          },

          itemVisible (item) {
            if(!this.inputValue.toLowerCase()){
              if(item.accountType == "primary"){
                return true
              }
            }else{
              let currentName = item.customerName.toLowerCase()+'-'+item.account.toLowerCase();
              let currentInput = this.inputValue.toLowerCase()
              return currentName.includes(currentInput)
            }
          },
          showList(){
            this.showDropdown = true;
            if(this.accountList.length == 0){
              this.getAccountListForCusip()
            }
           
          },
          hideList(){
            this.showDropdown = false
          },
          getAccountListForCusip(){
            this.accountListApiLoaded = false;
            this.loading = true;

            const auth = {
                headers: { 'org-token' : authService.getOrgToken() }
            };
            this.$http
            .get(
              config.baseUrlBidSide +
                "/inventory/account-map-list?cusipId="+this.selectedCusip.id,
                auth
            )
            .then(result => {
              this.getAllAccountList(result.data);
            })
          },
          getAllAccountList(accountListFromCusip){
            this.loading = true;
            const auth = {
                headers: { 'org-token' : authService.getOrgToken() }
            };
            this.$http
            .get(
              config.baseUrlBidSide +
                "/inventory/account-map-list",
                auth
            )
            .then(result => {
              this.loading = false;
              this.accountList = [];
              accountListFromCusip.forEach((e) => {
                e.accountType = "primary"; //account list in the cusip
                e.isCusipAccount = true;
                this.accountList.push(e)
                });
              result.data.forEach((e) => {
                accountListFromCusip.length == 0 ? e.accountType = "primary" : e.accountType = "secondary";
                e.isCusipAccount = false;
                this.accountList.push(e);// //account list in the system
                });
              this.accountListApiLoaded = true;
              // if(this.mode == 'EDIT'){ // set inventory for edit
              //   this.getOffer();
              // }
              // if(this.mode == 'MERGE'){
              //   this.setInventoryFromOffer(this.offerInventory);
              // }

            })
          },
          getAccountInventory(item){
            this.invLoading = true;
            const auth = {
                headers: { 'org-token' : authService.getOrgToken() }
            };
            this.$http
            .get(
              config.baseUrlBidSide +
                "/inventory/account-map-inventories?accountMappingId="+item.accountMappingId+"&cusipId="+this.selectedCusip.id,
                auth
            )
            .then((result) => {
              console.log("accItem",item);
              if(result.data.length == 0){
                let boughtDate = this.moment().format("MM/DD/YYYY");
                let invToAdd = {"accountMappingId":item.accountMappingId,"cusipId":this.selectedCusip.id,"quantity":0,"spread":0,"updateQuantity":0,"boughtDate":boughtDate,"cost":0,"updatePrice":0,"assignedQuantity":0}
                let self = this;
                this.invLoading = true;
                this.getSpread(invToAdd,function(spread){
                  invToAdd.spread = spread;
                  self.newInventory = [invToAdd];
                  self.invLoading = false;

                });
              }else{
                if(item.accountType  == 'primary'){
                  result.data.forEach((inv) => {
                    inv.updatePrice = inv.cost + parseFloat(inv.spread);
                    inv.quantity = inv.availableQuantity;
                    this.inventoryIDC = inv.closingPx

                  });
                  this.newInventory = result.data;
                   
                }else{
                  this.newInventory = [{"accountMappingId":item.accountMappingId,"cusipId":this.selectedCusip.id,"quantity":0,"spread":0,"updateQuantity":0,"boughtDate":"","cost":0,"updatePrice":0,"assignedQuantity":0}]
                }
                this.invLoading = false;
                
              }
            })
          },
          getSpread(inv,cb){
            if(!inv.boughtDate){
              return
            }
            this.loading = true;
            const auth = {
                headers: { 'org-token' : authService.getOrgToken() }
            };
            let formatedDate = this.moment(inv.boughtDate).format("MM/DD/YYYY"); 
            inv.accountMappingId = inv.id ? inv.accountMapping.id : inv.accountMappingId;
            this.$http
            .get(
              config.baseUrlBidSide +
                "/inventory/spread?accountMappingId="+inv.accountMappingId+"&date="+formatedDate,
                auth
            )
            .then((result) => {
              this.loading = false;
              inv.spread = result.data;
              if(cb){
                cb(result.data)
              }
            })
          },
          addNewInventory(inventory){
            if(!this.checkInventory(inventory)){
              var removeInventoryWithQtyZero = inventory.filter( inv => inv.updateQuantity > 0);
              // console.log(inventory);
              // console.log(removeInventoryWithQtyZero);
              var addedInv = { account :this.selectedAccount,inventory : removeInventoryWithQtyZero };
              if(removeInventoryWithQtyZero.length > 0){
                this.addedInventory.push(addedInv);
                this.clearAddInventoryForm();
                this.setOfferValues();
              }
              
            }
          },
          checkInventory(inv){
            var self = this;
            var validationError = false;
            let cusipType = this.selectedCusip.offeringTypeId === 1 ? "Munis" : "Corporates";

            inv.forEach((data) =>{
              //#8400
              // if(!data.boughtDate){
              //   validationError = true;
              //   self.$alert("Holding boughtDate is required","","error");
              //   return validationError;
              // }
              if(!data.cost){
                validationError = true;
                self.$alert("Holding cost is required","","error");
                return validationError;
              }
              if(!data.quantity){
                validationError = true;
                self.$alert("Holding quantity is required","","error");
                return validationError;
              }
              if(inv.length == 1 && !data.updateQuantity){
                //Offer qty field is required field when only one inventory available.
                //If multiple inventory comes user has ability add any inventory to offer.
                validationError = true;
                self.$alert("Offer quantity is required","","error");
                return validationError;
              }
              if(data.updateQuantity && cusipType == 'Munis' &&  data.updateQuantity % 5 != 0 ){
                validationError = true;
                self.$alert("Offer quantity is not multiples of 5","","error");
                return validationError;
              }
              if(data.updateQuantity && !data.updatePrice){
                validationError = true;
                self.$alert("Offer price is required","","error");
                return validationError;
              }
              if(data.quantity  < data.updateQuantity){
                validationError = true;
                self.$alert("Quantity entered is greater than available quantity to offer.","","error");
                return validationError;
              }
              //if(data.updateQuantity && (data.quantity - data.assignedQuantity) < data.updateQuantity){
              //  validationError = true;
              //  if(data.quantity == data.assignedQuantity){
              //      self.$alert("Holding already assigned","","error");
              //    }else{
              //      self.$alert("Quantity entered is greater than available quantity to offer.","","error");
              //    }
              //  return validationError;
              //}
              
            });
            return validationError;
          },
          clearAddInventoryForm(){
            this.selectedAccount = "";
            this.newInventory = [];
          },
          deleteInventory(removeIndex,inv){
            var message = "Are you sure you want to delete this holding? ";
            this.$confirm(message,"Delete holding","",{confirmButtonText:"Delete",cancelButtonText : "No"}).then(() => {
              this.addedInventory.splice(removeIndex, 1);
              if(this.mode == 'EDIT'){
                inv.forEach((data) => {
                  if(this.inventoryExistInCurrentOffer(data.id)){
                    this.deletedInventoryIds.push(data.id);
                  }
                });
              }
              this.setOfferValues();
              console.log(this.deletedInventoryIds)
              this.isHoldingValuesChanged = false
            });
          },
          resetToDefault(){
            this.selectedAccount = "";
            this.accountList = [];
            this.newInventory = [];
            this.addedInventory = [];
            this.offerQuantity = 0;
            this.offerCost = 0;
            this.offerPrice = 0;
            this.calculatedYield = 0;
            this.yieldSpread = 0;
            this.offeringObj.minimum = 0;
            this.offeringObj.incrementVal = 0;
            this.offeringObj.balance = 0;
            this.offerTmcPrice = 0;
            this.offerTwdPrice = 0;
            this.offerIbpPrice = 0;
            this.offerMktxPrice = 0;
          },
          getBrokerAccountList(){
            this.ecnAccountListLoading = true;
           // console.log("ecn list call")
            const auth = {
              headers: {'org-token' : authService.getOrgToken() }
            };
            this.$http
              .get(
                config.baseUrlBidSide + "/account/list?ecn=IBP,TMC,TWD,MKTX",
                auth
              )
              .then(response => {
                  this.bpAccountList = response.data.filter((item) => {
                      return item.ecn == 'IBP' && item.accountValue != 'SMU0000042'
                  });
                  this.tmcAccountList = response.data.filter((item) => {
                      return item.ecn == 'TMC'
                  });
                  this.twAccountList = response.data.filter((item) => {
                      return item.ecn == 'TWD'
                  });
                  this.mktxAccountList = response.data.filter((item) => {
                      return item.ecn == 'MKTX'
                  });
                  
                  //this.loading = false;
                 // console.log("ecn list End");
                  this.getOrganizationSetting()
              })
              .catch(e => {
                console.log(e);
              });
          },
          getTraderSetting(){
            //this.loading = true;
            const auth = {
              headers: {'org-token' : authService.getOrgToken() }
            };
            this.$http
              .get(
                config.baseUrlBidSide +
                "/user/offering?cognitoSub="+
                authService.getUser().cognitoSub,
                auth
              )
              .then(response => {
                this.traderSettings = response.data;
                if(this.mode != 'EDIT'){// settilement date ava in get offer
                  this.offeringObj.tmcBrokerAccountId = this.traderSettings.tmcAccountId || "";
                  this.offeringObj.twdBrokerAccountId = this.traderSettings.twdAccountId  || "";
                  this.offeringObj.ibpBrokerAccountId = this.traderSettings.ibpAccountId  || "";
                  this.offeringObj.mktxBrokerAccountId = this.traderSettings.mktxAccountId  || "";
                }

                //this.loading = false;
                
              })
          },
          getOrganizationSetting(){
            //this.loading = true;
           // console.log("Org list call")
            const auth = {
              headers: {'org-token' : authService.getOrgToken() }
            };
            this.$http
              .get(
                config.baseUrlBidSide +
                "/organization/bid-settings?type=OFFER",
                auth
              )
              .then(response => {
                this.orgSettings = response.data;
                this.offeringObj.offerValidity = 1;
                if(this.mode != 'EDIT'){// settilement date ava in get offer
                  this.offeringObj.settlementDate = this.orgSettings.settlementDate;
                }

                this.ecnAccountListLoading = false;
                this.getCusipDetails();
              })
          },
          setOfferValues(updatefromButtonClick){
            let totalQuantity = 0;
            let invOfferprices = [];
            let totalInvAvgCost = 0;
            this.addedInventory.forEach((result) => {
              result.inventory.forEach((data) => {
                 totalQuantity += data.updateQuantity;
                 invOfferprices.push(data.updatePrice);
                 totalInvAvgCost += (data.updateQuantity * data.cost);
              })
            });
            this.offerQuantity = totalQuantity;
           // let totalOfferingPrice = invOfferprices.reduce((a, b) => a + b, 0);
            this.offerCost = parseFloat(totalInvAvgCost / totalQuantity).toFixed(3) || 0;
            if(updatefromButtonClick){
              this.$alert("Holding updated.","","success");
            }
            if(this.mode == 'ADD' || this.mode == 'TRADE' || this.mode == 'MERGE'){
              this.offerPrice = Number(Math.max.apply(Math, invOfferprices).toFixed(3));
              this.setEcnPriceDefault(this.offerPrice);
              this.setOfferingSpread();
              this.getYieldValue();
            }
            this.setMinIncBalValues(this.offerQuantity);

          },
          setMinIncBalValues(offerQtv){
            console.log("updating min values")
            let cusipType = this.selectedCusip.offeringTypeId === 1 ? "Munis" : "Corporates";
            if(cusipType == "Munis" ){
              if(offerQtv <= 5){//Bal = 0, Min = 5, Inc = 5
                this.offeringObj.minimum = 5
                this.offeringObj.incrementVal = 5
                this.offeringObj.balance = 0
              }
              if(offerQtv > 5 && offerQtv <= 10){//Bal = 0, Min = 10, Inc = 5
                this.offeringObj.minimum = 10
                this.offeringObj.incrementVal = 5
                this.offeringObj.balance = 0
              }
              if(offerQtv > 10 &&  offerQtv <= 15){// Bal = 0, Min = 15, Inc = 5
                this.offeringObj.minimum = 15
                this.offeringObj.incrementVal = 5
                this.offeringObj.balance = 0
              }
              if(offerQtv > 15){// Bal = 10, Min = 10, Inc = 5
                this.offeringObj.minimum = 10
                this.offeringObj.incrementVal = 5
                this.offeringObj.balance = 10
              }
            }
            if(cusipType == "Corporates" ){
              if(offerQtv <= 5){//Bal = 0, Min = 5, Inc = 1
                this.offeringObj.minimum = 5
                this.offeringObj.incrementVal = 1
                this.offeringObj.balance = 0
              }
              if(offerQtv > 5 && offerQtv <= 10){//Bal = 0, Min = 10, Inc = 1
                this.offeringObj.minimum = 10
                this.offeringObj.incrementVal = 1
                this.offeringObj.balance = 0
              }
              if(offerQtv > 10 && offerQtv <= 15){// Bal = 0, Min = 15, Inc = 1
                this.offeringObj.minimum = 15
                this.offeringObj.incrementVal = 1
                this.offeringObj.balance = 0
              }
              if(offerQtv > 15){// Bal = 10, Min = 10, Inc = 1
                this.offeringObj.minimum = 10
                this.offeringObj.incrementVal = 1
                this.offeringObj.balance = 10
              }
            }
          },
          callSetDefault(){
            setTimeout(()=> {
              this.setOfferValues();
            },100);
          },
          updateInventory(inv){
            this.isHoldingValuesChanged = false;
            let self = this;
            let invQtyError = false;
            let cusipType = this.selectedCusip.offeringTypeId === 1 ? "Munis" : "Corporates";
            //console.log("Qty",inv)
            inv.forEach((data) =>{
              
              if(!data.quantity){
                invQtyError = true;
                self.$alert("Holding quantity is required","","error");
                return false;
              }
              if(!data.updatePrice){
                invQtyError = true;
                self.$alert("Offer price is required","","error");
                return false;
              }
              // if(this.mode != 'ADD' && this.offeringObj.status == 'HOLD_ON_HOLDINGS_UPLOAD'){
              //   if((data.quantity - data.assignedQuantity) < data.updateQuantity){
              //     if(data.quantity == data.assignedQuantity){
              //         self.$alert("Holding already assigned","","error");
              //       }else{
              //         self.$alert("Quantity entered is greater than available quantity to offer.","","error");
              //       }
              //       invQtyError = true;
              //       return false;
              //   }
              // }
              //Minus selected holding assign qty(offerInventoryQuantity) from total assinged qty (assignedQuantity) to get Available qty
              //Minus Available Qty from  Total quantity (quantity) 
              //Check its greater than enterd Qty (updateQuantity)
              //console.log(data.offerInventoryQuantity ,data.updateQuantity)
              // if(this.mode != 'ADD' && this.offeringObj.status != 'HOLD_ON_HOLDINGS_UPLOAD'){
              //   if((data.quantity - (data.assignedQuantity - data.offerInventoryQuantity)) < data.updateQuantity){
              //     if(data.quantity == data.assignedQuantity){
              //       self.$alert("Holding already assigned","","error");
              //       if(data.offerInventoryQuantity){
              //         data.updateQuantity = data.offerInventoryQuantity
              //       }
              //     }else{
              //       self.$alert("Quantity entered is greater than available quantity to offer.","","error");
              //       if(data.offerInventoryQuantity){
              //         data.updateQuantity = data.offerInventoryQuantity
              //       }
              //     }
              //     invQtyError = true;
              //     return false;
              //   }
              // }
              //Check offer quantity more than available quantity
              // if(this.mode == 'ADD' || this.mode == 'TRADE'){
              //   if((data.quantity - data.assignedQuantity) < data.updateQuantity){
              //     if(data.quantity == data.assignedQuantity){
              //         self.$alert("Holding already assigned","","error");
              //         data.updateQuantity = data.quantity - data.assignedQuantity;
              //       }else{
              //         self.$alert("Quantity entered is greater than available quantity to offer.","","error");
              //         data.updateQuantity = data.quantity - data.assignedQuantity;
              //       }
              //       invQtyError = true;
              //       return false;
              //   }
              // }

              if(data.quantity  < data.updateQuantity){
                self.$alert("Quantity entered is greater than available quantity to offer.","","error");
                invQtyError = true;
                 return false;
              }
              
              if(cusipType == 'Munis' &&  data.updateQuantity % 5 != 0 ){
                invQtyError = true;
                self.$alert("Offer quantity is not multiples of 5","","error");
                return false;
              }
                              
            });
            if(!invQtyError){
              this.setOfferValues('buttonclick');
            }

          },
          getOffer(){
            this.loading = true;
            const auth = {
                headers: { 'org-token' : authService.getOrgToken() }
            };
            this.$http
            .get(
              config.baseUrlBidSide +
                "/offer/"+this.selectedOffer.id,
                auth
            )
            .then(result => {
              this.inventoryListInOffer = result.data.inventoryList;
              this.deletedInventoryListInOffer = result.data.deletedInventoryList;
              this.setInventoryFromOffer(this.inventoryListInOffer);
              // let savedInventory = []; 
              // this.inventoryListInOffer.forEach((inventory) => { // Set Offer Inverntory
              //   let selectedAccount = this.getInvAccount(inventory.accountMappingId)
              //   let selectedInventory = [{"id" : inventory.inventoryId ,"accountMappingId":inventory.accountMappingId,"cusipId":inventory.cusipId,"quantity":inventory.quantity,"updateQuantity":inventory.offerInventoryQuantity,"boughtDate":inventory.boughtDate,"cost":inventory.cost,"updatePrice":inventory.offerInventoryPrice,"assignedQuantity":inventory.assignedQuantity}]
              //   var addedInv = { account :selectedAccount,inventory : selectedInventory };
              //   savedInventory.push(addedInv);
              // });
              // if(savedInventory.length > 0){
              //   this.addedInventory = savedInventory;
              // }
              this.offeringObj.tmcBrokerAccountId = result.data.tmcBrokerAccountId || "";
              this.offeringObj.twdBrokerAccountId = result.data.twdBrokerAccountId  || "";
              this.offeringObj.ibpBrokerAccountId = result.data.ibpBrokerAccountId  || "";
              this.offeringObj.mktxBrokerAccountId = result.data.mktxBrokerAccountId  || "";
              this.offeringObj.settlementDate = result.data.settlementDate;
              // this.offeringObj.createSource = result.data.createSource.includes('arbs') ? "ARBS" : "IMS";
              this.loading = false;
            })
          },
          getInvAccount(accountMappingId){
            let inv  = this.accountList.find(o => o.accountMappingId === accountMappingId);
            if(inv){
                return inv 
            }
          },
          setEcnPriceDefault(offerPrice){
            if(this.ecnData){
              let tmcData = this.ecnData.find((item) => {return item.ecnShortName == 'TMC'});
              let tmcApplyIncrease = tmcData.applyIncrease ?  tmcData.increase : 0;
              let twdData = this.ecnData.find((item) => {return item.ecnShortName == 'TWR-EXE'});
              let twdApplyIncrease = twdData.applyIncrease ?  twdData.increase : 0;
              let ibpData = this.ecnData.find((item) => {return item.ecnShortName == 'KBP'});
              let ibpApplyIncrease = ibpData.applyIncrease ?  ibpData.increase : 0;
              let mktxData = this.ecnData.find((item) => {return item.ecnShortName == 'MKTX'});
              let mktxApplyIncrease = mktxData.applyIncrease ?  mktxData.increase : 0;
                //console.log(offerPrice + tmcApplyIncrease  ,offerPrice , tmcApplyIncrease)
                if(this.offeringObj && this.offeringObj.createSource && !this.offeringObj.createSource.toLocaleLowerCase().includes('arbs')){
                  this.offerTmcPrice = (parseFloat(offerPrice) + parseFloat(tmcApplyIncrease)).toFixed(3);
                  this.offerTwdPrice = (parseFloat(offerPrice) + parseFloat(twdApplyIncrease)).toFixed(3);
                  this.offerIbpPrice = (parseFloat(offerPrice) + parseFloat(ibpApplyIncrease)).toFixed(3);
                  this.offerMktxPrice = (parseFloat(offerPrice) + parseFloat(mktxApplyIncrease)).toFixed(3);
                }else{
                  this.offerTmcPrice = offerPrice;
                  this.offerTwdPrice = offerPrice;
                  this.offerIbpPrice = offerPrice;
                  this.offerMktxPrice = offerPrice;
                }
                
            }else{
              this.getEcns(offerPrice);
            }
            this.setOfferingSpread();
           
          },
          getInventoryAccountList(){
              this.loading = true;
              const auth = {
                  headers: { 'org-token' : authService.getOrgToken() }
              };
              this.$http
              .get(
                config.baseUrlAutoBidder +
                  "/inventory/accounts",
                  auth
              )
              .then(result => {
                this.inventoryAccounts = result.data || []

              })       
          },
          getEcns(offerPrice){
              this.loading = true;
              const auth = {
                  headers: { 'org-token' : authService.getOrgToken() }
              };
              this.$http
              .get(
                config.baseUrlBidSide +
                  "/ecn/list",
                  auth
              )
              .then(result => {
                this.ecnData = result.data;
                this.loading = false;
                let tmcData = this.ecnData.find((item) => {return item.ecnShortName == 'TMC'});
                let tmcApplyIncrease = tmcData.applyIncrease ?  tmcData.increase : 0;
                let twdData = this.ecnData.find((item) => {return item.ecnShortName == 'TWR-EXE'});
                let twdApplyIncrease = twdData.applyIncrease ?  twdData.increase : 0;
                let ibpData = this.ecnData.find((item) => {return item.ecnShortName == 'KBP'});
                let ibpApplyIncrease = ibpData.applyIncrease ?  ibpData.increase : 0;
                let mktxData = this.ecnData.find((item) => {return item.ecnShortName == 'MKTX'});
                let mktxApplyIncrease = mktxData.applyIncrease ?  mktxData.increase : 0;
                if(this.offeringObj && this.offeringObj.createSource && !this.offeringObj.createSource.toLocaleLowerCase().includes('arbs')){
                  this.offerTmcPrice = (parseFloat(offerPrice) + parseFloat(tmcApplyIncrease)).toFixed(3);
                  this.offerTwdPrice = (parseFloat(offerPrice) + parseFloat(twdApplyIncrease)).toFixed(3);
                  this.offerIbpPrice = (parseFloat(offerPrice) + parseFloat(ibpApplyIncrease)).toFixed(3);
                  this.offerMktxPrice = (parseFloat(offerPrice) + parseFloat(mktxApplyIncrease)).toFixed(3);

                }else{
                  this.offerTmcPrice = offerPrice;
                  this.offerTwdPrice = offerPrice;
                  this.offerIbpPrice = offerPrice;
                  this.offerMktxPrice = offerPrice;
                }
                
                //console.log("ecn price set",this.offeringObj);
              })       
          },
          setCalculatedYield(calculatedYield){
            
            this.calculatedYield = calculatedYield > 0 ? calculatedYield : this.calculatedYield;
            this.yieldModalOpen = false;
          },
          setCalculatedPrice(calculatedPrice){
            //console.log("price",calculatedPrice)
            this.offerPrice = calculatedPrice > 0 ? calculatedPrice : this.offerPrice;
            this.yieldModalOpen = false;
            this.setEcnPriceDefault(this.offerPrice)
          },
          setOfferingSpread(){
            this.yieldSpread = (parseFloat(this.offerPrice) - parseFloat(this.offerCost)).toFixed(3);
          },
          setInventoryFromOffer(inventoryArray){
            let savedInventory = []; 
            inventoryArray.forEach((inventory) => { // Set Offer Inverntory
              let selectedAccount = {account : inventory.account,customerName : inventory.customerName}
              let selectedInventory = [{"id" : inventory.inventoryId ,"accountMappingId":inventory.accountMappingId,"cusipId":inventory.cusipId,"quantity":inventory.availableQuantity,"updateQuantity":inventory.offerInventoryQuantity,"offerInventoryQuantity":inventory.offerInventoryQuantity ,"boughtDate":inventory.boughtDate,"cost":inventory.cost,"updatePrice":inventory.offerInventoryPrice,"assignedQuantity":inventory.assignedQuantity,"spread":inventory.spread,"closingPx":inventory.closingPx}]
              var addedInv = { account :selectedAccount,inventory : selectedInventory };
              savedInventory.push(addedInv);
              this.inventoryIDC = inventory.closingPx;
            });
            if(savedInventory.length > 0){
              this.addedInventory = savedInventory;
              if(this.mode == 'MERGE'){
                this.setOfferValues();
              }
            }
          },
          setSpreadToOfferPrice(inv){
            inv.updatePrice = Number(inv.cost)+Number(inv.spread);
          },
          getCusipDetails(){
            //this.loading = true;
            if(!this.selectedCusip.id){
              return false;
            }
             const auth = {
                headers: { 'org-token' : authService.getOrgToken() }
            };
            this.$http
            .get(
              config.baseUrlBidSide +
                "/cusip/"+this.selectedCusip.id+"?showCalculationInput=true",auth
            )
            .then((result) => {
              this.loading = false;
              let calculationInput = result.data.calculationInput
              //result.data.coupon = result.data.secMasterCoupon ?  result.data.secMasterCoupon : result.data.coupon;
              this.calculate.coupon = calculationInput.coupon;
              this.calculate.call = calculationInput.call ? true : false;
              this.calculate.put = calculationInput.put ? true : false;
              this.calculate.maturitydate = calculationInput.maturitydate;
              this.calculate.maturityPrice = calculationInput.maturityPrice;
              this.calculate.nextCall = calculationInput.nextCall;
              this.calculate.callPrice = calculationInput.callPrice;
              this.calculate.parDate = calculationInput.parDate;
              this.calculate.parPrice = calculationInput.parPrice;
              this.calculate.putDate = calculationInput.putDate;
              this.calculate.putPrice = calculationInput.putPrice;
              this.calculate.mandDate = calculationInput.mandDate;
              this.calculate.mandprice = calculationInput.mandprice;
              this.calculate.escrowToMaturityDate = calculationInput.escrowToMaturityDate ;
              this.calculate.preRefundedDate = calculationInput.preRefundedDate;
              this.calculate.escrowToMaturityPrice = calculationInput.escrowToMaturityPrice ;
              this.calculate.preRefundedPrice = calculationInput.preRefundedPrice;
              
              this.calculate.bid = result.data.bidPrice > 0 ? (result.data.bidPrice / 10) : 0;
              this.calculate.ask = result.data.askPrice > 0 ? (result.data.askPrice / 10) : 0 ;
              this.calculate.settlement = this.orgSettings.settlementDate;
              this.secMasterAvailable = result.data.isSecurityMasterExist;
              //this.loading = false;

              if(this.mode == 'MERGE'){
                this.getYieldValue();
              }

              
            })
          },
          getYieldValue(){
            // if(!this.secMasterAvailable){
            //   return;
            // }
            this.loading = true;
            let data = {};
                data.price = this.offerPrice+"";
                data.settlement = this.offeringObj.settlementDate ? this.moment(this.offeringObj.settlementDate).format("MM/DD/YYYY") : "null";
                data.maturitydate = this.calculate.maturitydate ? this.moment(this.calculate.maturitydate).format("MM/DD/YYYY") : "null";
                data.yield = "";
                data.coupon = this.calculate.coupon;
                data.callPrice = this.calculate.callPrice || 0;
                data.maturityPrice = this.calculate.maturityPrice || 0;
                data.parPrice = this.calculate.parPrice || 0;
                data.preRefundedPrice = this.calculate.preRefundedPrice || 0;
                data.escrowToMaturityPrice = this.calculate.escrowToMaturityPrice || 100;
                data.call = this.calculate.call;
                data.put = this.calculate.put;
                data.putPrice = this.calculate.putPrice || 0;
                data.mandprice = this.calculate.mandprice || 0;
        
                data.preRefundedDate = this.calculate.preRefundedDate ? this.moment(this.calculate.preRefundedDate).format("MM/DD/YYYY") : "null";
                data.escrowToMaturityDate = this.calculate.escrowToMaturityDate ? this.moment(this.calculate.escrowToMaturityDate).format("MM/DD/YYYY") : "null"
                data.parDate = this.calculate.parDate ? this.moment(this.calculate.parDate).format("MM/DD/YYYY") : "null";
                data.putDate = this.calculate.putDate ? this.moment(this.calculate.putDate).format("MM/DD/YYYY") : "null";
                data.mandDate = this.calculate.mandDate ?  this.moment(this.calculate.mandDate).format("MM/DD/YYYY") : "null";
                data.nextCall = this.calculate.nextCall ? this.moment(this.calculate.nextCall).format("MM/DD/YYYY") : "null";
                //console.log(data);
            this.$http
            .post(
              config.baseUrlBidSide +
                "/yield/calculation ",
                data
            )
            .then((res) => {
                this.loading = false;
                this.calculatedYield = res.data.calcPrice.toFixed(3);
               // console.log("Yield cal",this.offeringObj.yield)
            }).catch(() => this.loading = false) 
          },
          getPriceValue(){
            // if(!this.secMasterAvailable){
            //   return;
            // }
            this.loading = true;
            let data = {};
                data.price = "";
                data.settlement = this.offeringObj.settlementDate ? this.moment(this.offeringObj.settlementDate).format("MM/DD/YYYY") : "null";
                data.maturitydate = this.calculate.maturitydate ? this.moment(this.calculate.maturitydate).format("MM/DD/YYYY") : "null";
                data.yield = this.calculatedYield;
                data.coupon = this.calculate.coupon;
                data.callPrice = this.calculate.callPrice || 0;
                data.maturityPrice = this.calculate.maturityPrice || 0;
                data.parPrice = this.calculate.parPrice || 0;
                data.preRefundedPrice = this.calculate.preRefundedPrice || 0;
                data.escrowToMaturityPrice = this.calculate.escrowToMaturityPrice || 100;
                data.call = this.calculate.call;
                data.put = this.calculate.put;
                data.putPrice = this.calculate.putPrice || 0;
                data.mandprice = this.calculate.mandprice || 0;
        
                data.preRefundedDate = this.calculate.preRefundedDate ? this.moment(this.calculate.preRefundedDate).format("MM/DD/YYYY") : "null";
                data.escrowToMaturityDate = this.calculate.escrowToMaturityDate ? this.moment(this.calculate.escrowToMaturityDate).format("MM/DD/YYYY") : "null"
                data.parDate = this.calculate.parDate ? this.moment(this.calculate.parDate).format("MM/DD/YYYY") : "null";
                data.putDate = this.calculate.putDate ? this.moment(this.calculate.putDate).format("MM/DD/YYYY") : "null";
                data.mandDate = this.calculate.mandDate ?  this.moment(this.calculate.mandDate).format("MM/DD/YYYY") : "null";
                data.nextCall = this.calculate.nextCall ? this.moment(this.calculate.nextCall).format("MM/DD/YYYY") : "null";
                //console.log(data);
            this.$http
            .post(
              config.baseUrlBidSide +
                "/yield/calculation-price",
                data
            )
            .then((res) => {
                this.loading = false;
                if(res.data.calcPrice !=0){
                  this.offerPrice = Number(res.data.calcPrice.toFixed(3));
                  this.setEcnPriceDefault(this.offerPrice)
                }
            }).catch(() => this.loading = false) 
          },
        },
        mounted(){
          this.offeringObj.offerType = "PRICE";
          this.offeringObj.createSource = "self";
          if(this.mode == 'ADD'){
            if(this.offerCusip){
              this.selectedCusip  = { ...this.offerCusip};
              //this.getAccountListForCusip()
            }
            else{
              this.selectedCusip = {};
            }
          }
          if(this.mode == 'TRADE'){
            this.selectedCusip = {};
          }
          if(this.mode == 'MERGE'){
            if(this.offerCusip){
              this.selectedCusip  = { ...this.offerCusip};
              //this.getAccountListForCusip();
              this.setInventoryFromOffer(this.offerInventory);
            }
            console.log(this.mode)
          }
          if(this.mode == 'EDIT'){
            this.selectedCusip  = { ...this.offerCusip};
            this.offeringObj    = this.selectedOffer;
            this.offerPrice     = this.offeringObj.price
            this.offerQuantity  = this.offeringObj.quantity;
            this.offerCost      = Number(this.offeringObj.cost.toFixed(3));
            this.offerIbpPrice  = this.selectedOffer.ibpprice;
            this.offerTmcPrice  = this.selectedOffer.tmcprice;
            this.offerTwdPrice  = this.selectedOffer.twdprice;
            this.offerMktxPrice  = this.selectedOffer.mktxPrice;
            this.yieldSpread = (parseFloat(this.offerPrice) - parseFloat(this.offerCost)).toFixed(3);
            //this.getAccountListForCusip();
            this.offeringObj.offerType = this.selectedOffer.offerType;
            if(this.selectedOffer.status == "MSRB" || this.selectedOffer.status == "HOLD"){
              this.checkedStatus.push(this.selectedOffer.status);
            }
             if(this.selectedOffer.status == "MSRB_HOLD"){
              this.checkedStatus.push("MSRB");
            }
            //MSRB_HOLD
            this.calculatedYield = this.selectedOffer.yield;
            this.getOffer();
          }
          this.getBrokerAccountList();
          this.getTraderSetting();
          //this.getOrganizationSetting();
          this.getInventoryAccountList();

        }
    };
    </script>
    <style scoped>
    .warning-message{
      color:#ffa500;
      position: absolute;
      font-size: 10px;

    }
    .shake {
      animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
      transform: translate3d(0, 0, 0);
    }

    @keyframes shake {
      10%,
      90% {
        transform: translate3d(-1px, 0, 0);
      }

      20%,
      80% {
        transform: translate3d(2px, 0, 0);
      }

      30%,
      50%,
      70% {
        transform: translate3d(-4px, 0, 0);
      }

      40%,
      60% {
        transform: translate3d(4px, 0, 0);
      }
    }
    </style>